import { cx } from "../../utils/functions";

interface AlertProps {
  children?: React.JSX.Element | string;
  className?: string;
  soft?: boolean;
  variant?: "info" | "warning" | "error" | "success";
}

const getIconColorClass = (variant?: "info" | "warning" | "error" | "success") => {
  switch (variant) {
    case "info":
      return "stroke-info";
    case "warning":
      return "stroke-warning";
    case "error":
      return "stroke-error";
    case "success":
      return "stroke-success";
    default:
      return "stroke-info";
  }
};

const InfoIcon = ({ variant }: { variant?: "info" | "warning" | "error" | "success" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={cx(getIconColorClass(variant), "h-6 w-6 shrink-0")}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
  );
};

export const Alert = ({ children, className, soft, variant }: AlertProps) => {
  return (
    <div
      role={"alert"}
      className={cx(
        "alert",
        soft && "alert-soft",
        variant === "info" && "alert-info",
        variant === "warning" && "alert-warning",
        variant === "error" && "alert-error",
        variant === "success" && "alert-success",
        className,
      )}
    >
      <InfoIcon variant={variant} />
      {children}
    </div>
  );
};
